import { KEY_SYMBOLS_MAP } from "utils/keyboard";

/**
 * Config that can be passed to the command palette, without those already
 * defined in the base Command type.
 */

export const getShortcut = (binding: string): string[] => {
  return binding
    .split("+")
    .map((key) => KEY_SYMBOLS_MAP[key] ?? key.replace("Key", ""));
};
